import { useQuery } from 'src/graphql';
import { JOBS_PAGE_QUERY } from 'src/graphql/job/query';

export default ({
  limit = 1000,
  offset = 0,
  q = '',
  orderBy = 'id',
  orderDirection = 'asc',
  columnFilters = [],
}, shouldThrow = true) =>
  useQuery(JOBS_PAGE_QUERY, {
    variables: { limit, offset, q, orderBy, orderDirection, columnFilters },
    fetchPolicy: 'network-only',
  }, shouldThrow);
